export default __webpack_public_path__ + "static/aboutImage2-ba0a9dda91e63bd2899091f041b6be5f.png";